export const lineColor = [
  "match",
  ["get", "class"],
  "wood",
  "rgb(0, 19, 124)",
  "scrub",
  "rgb(80, 106, 252)",
  "crop",
  "rgb(143, 160, 255)",
  "grass",
  "rgb(207, 214, 255)",
  "rgb(255, 147, 147)",
];

export const polygonColor = [
  "match",
  ["get", "class"],
  "wood",
  "rgb(94, 0, 0)",
  "scrub",
  "rgb(176, 3, 3)",
  "crop",
  "rgb(231, 101, 6)",
  "grass",
  "rgb(218, 197, 7)",
  "rgb(85, 193, 0)",
];
